import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/leave-sub-items',
    name: 'leave-sub-item',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-sub-item')
  }
]
